import { connect } from 'react-redux';
import { selectors as staffSelectors } from 'ducks/staff';
import PurchaseOrderLookup from './PurchaseOrderLookup';
import React from 'react';
import { IPurchaseOrderLookupProps } from './PurchaseOrderLookup.properties';
import { IBasicLookupFieldHandle } from '@markinson/uicomponents-v2/BasicLookupField/BasicLookup.properties';

const mapStateToProps = (state) => ({
    DefaultWarehouse: staffSelectors.staff(state)?.defaultWarehouseEntity
});

const ConnectedComponent = connect(mapStateToProps, null)((props: Readonly<IPurchaseOrderLookupProps>) => {
    return (<PurchaseOrderLookup
        {...props} />);
});

export default React.forwardRef(
    (props: Readonly<IPurchaseOrderLookupProps>, ref: React.Ref<IBasicLookupFieldHandle>) => {

        return <ConnectedComponent {...props} fieldRef={ref} />;
    });
